module.exports = components_vue;